export * from './patients.byphone.actions'
export * from './patients.bymistoken.actions'

export const patientsRequest = () => ({ type: 'PATIENTS_REQUEST' } as const)
export const patientsClear = () => ({ type: 'PATIENTS_CLEAR' } as const)